export default "__VITE_ASSET__CYkmvqj7__"